
export const headerData = {
    name: 'Gedeon MATABARO',
    title: "Fulstack Dev",
    desciption: "I am Gedeon MATABARO, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about utilizing technology to drive positive change in the world.",
    image: 'https://i.ibb.co/5k2SRfw/Gedeon-top-G-sq.jpg' ,
    imagebw: 'https://i.ibb.co/2ShZkP7/Gedeon-top-G-sq-b.jpg',
    resumePdf: 'https://drive.google.com/file/d/1HiNmcOuFFViPKd231Pi3Gt3uqRojj6F2/view?usp=sharing'
}
// comment